// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather-map {
  padding: var(--spacing-lg);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.weather-map .card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacing-md);
  flex-wrap: wrap;
  gap: var(--spacing-sm);
}

.weather-map .title-section {
  display: flex;
  flex-direction: column;
}

.weather-map .card-title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.weather-map .card-subtitle {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 2px;
}

.weather-map .map-controls {
  display: flex;
  gap: var(--spacing-sm);
}

.weather-map .zoom-controls {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  padding: 3px;
  border: 1px solid var(--border-color);
}

.weather-map .zoom-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--text-muted);
  cursor: pointer;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.weather-map .zoom-btn:hover:not(:disabled) {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.weather-map .zoom-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.weather-map .zoom-level {
  font-size: 0.7rem;
  color: var(--text-muted);
  min-width: 18px;
  text-align: center;
  font-family: 'Monaco', 'Consolas', monospace;
}

/* Layer Selector */
.weather-map .layer-selector {
  display: flex;
  gap: var(--spacing-xs);
  margin-bottom: var(--spacing-md);
  flex-wrap: wrap;
}

.weather-map .layer-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: var(--spacing-xs) var(--spacing-sm);
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  font-size: 0.75rem;
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
}

.weather-map .layer-btn:hover {
  color: var(--text-primary);
  border-color: var(--accent-cyan);
}

.weather-map .layer-btn.active {
  background: var(--accent-blue);
  color: white;
  border-color: var(--accent-blue);
}

.weather-map .layer-name {
  font-size: 0.7rem;
}

/* Map Container */
.weather-map .map-container {
  flex: 1 1;
  min-height: 300px;
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 1px solid var(--border-color);
  position: relative;
}

.weather-map .windy-iframe {
  width: 100%;
  height: 100%;
  min-height: 300px;
  border: none;
  display: block;
}

/* Placeholder */
.weather-map .map-placeholder {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  gap: var(--spacing-sm);
}

.weather-map .placeholder-icon {
  opacity: 0.4;
}

/* Footer */
.weather-map .map-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--spacing-sm);
  padding-top: var(--spacing-sm);
  border-top: 1px solid var(--border-color);
}

.weather-map .map-coords {
  font-size: 0.7rem;
  color: var(--text-muted);
  font-family: 'Monaco', 'Consolas', monospace;
}

.weather-map .map-attribution {
  font-size: 0.65rem;
  color: var(--text-muted);
}

.weather-map .map-attribution a {
  color: var(--accent-cyan);
  text-decoration: none;
}

.weather-map .map-attribution a:hover {
  text-decoration: underline;
}

/* Responsive */
@media (max-width: 600px) {
  .weather-map .layer-selector {
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
  }

  .weather-map .layer-name {
    display: none;
  }

  .weather-map .map-container {
    min-height: 250px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WeatherMap/WeatherMap.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".weather-map {\n  padding: var(--spacing-lg);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.weather-map .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: var(--spacing-md);\n  flex-wrap: wrap;\n  gap: var(--spacing-sm);\n}\n\n.weather-map .title-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.weather-map .card-title {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.weather-map .card-subtitle {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  margin-top: 2px;\n}\n\n.weather-map .map-controls {\n  display: flex;\n  gap: var(--spacing-sm);\n}\n\n.weather-map .zoom-controls {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  background: var(--bg-secondary);\n  border-radius: var(--radius-sm);\n  padding: 3px;\n  border: 1px solid var(--border-color);\n}\n\n.weather-map .zoom-btn {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-radius: var(--radius-sm);\n  transition: all var(--transition-fast);\n}\n\n.weather-map .zoom-btn:hover:not(:disabled) {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.weather-map .zoom-btn:disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.weather-map .zoom-level {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  min-width: 18px;\n  text-align: center;\n  font-family: 'Monaco', 'Consolas', monospace;\n}\n\n/* Layer Selector */\n.weather-map .layer-selector {\n  display: flex;\n  gap: var(--spacing-xs);\n  margin-bottom: var(--spacing-md);\n  flex-wrap: wrap;\n}\n\n.weather-map .layer-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: var(--spacing-xs) var(--spacing-sm);\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  color: var(--text-muted);\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n}\n\n.weather-map .layer-btn:hover {\n  color: var(--text-primary);\n  border-color: var(--accent-cyan);\n}\n\n.weather-map .layer-btn.active {\n  background: var(--accent-blue);\n  color: white;\n  border-color: var(--accent-blue);\n}\n\n.weather-map .layer-name {\n  font-size: 0.7rem;\n}\n\n/* Map Container */\n.weather-map .map-container {\n  flex: 1;\n  min-height: 300px;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n  position: relative;\n}\n\n.weather-map .windy-iframe {\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  border: none;\n  display: block;\n}\n\n/* Placeholder */\n.weather-map .map-placeholder {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted);\n  gap: var(--spacing-sm);\n}\n\n.weather-map .placeholder-icon {\n  opacity: 0.4;\n}\n\n/* Footer */\n.weather-map .map-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: var(--spacing-sm);\n  padding-top: var(--spacing-sm);\n  border-top: 1px solid var(--border-color);\n}\n\n.weather-map .map-coords {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  font-family: 'Monaco', 'Consolas', monospace;\n}\n\n.weather-map .map-attribution {\n  font-size: 0.65rem;\n  color: var(--text-muted);\n}\n\n.weather-map .map-attribution a {\n  color: var(--accent-cyan);\n  text-decoration: none;\n}\n\n.weather-map .map-attribution a:hover {\n  text-decoration: underline;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .weather-map .layer-selector {\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .weather-map .layer-name {\n    display: none;\n  }\n\n  .weather-map .map-container {\n    min-height: 250px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
